import React from 'react';
import moment from 'moment';
import SelectPeriod from './components/SelectPeriod/SelectPeriod';
import { useLocation } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import useRingList from './queries/useRingList';
import { getSearchParamsObj } from '../../helpers/getSearchParamsObj';
import { callHistoryFilters } from './constants/callHistoryFilters';
import { fromDateStr, toDateStr } from '../../helpers/utcDate';
import CallList from './components/CallList/CallList';
import ListenRecordModal from './components/ListenRecordModal/ListenRecordModal';
import SelectItem from './components/SelectItem/SelectItem';
import useCompanies from '../../queries/useCompanies';
import useOperators from './queries/useOperators';
import SearchItem from './components/SearchItem/SearchItem';
import useSetRefreshFn from '../../hooks/useSetRefreshFn';
import { callHistoryQueryKeys } from './queries/queryKeys';
import styles from './CallHistory.module.scss';
import { Icon, Tooltip } from 'antd';
import { exportToExcel } from './utils/exportToExcel';

const CallHistory = () => {
  const location = useLocation();
  const queryClient = useQueryClient();

  const params = getSearchParamsObj(location.search, callHistoryFilters);

  const { date, ...searchParams } = params;

  const hasDate = date?.length === 2;

  const { data: ringList, isFetching: isRingListFetching } = useRingList(
    {
      ...searchParams,
      fromDate: hasDate && fromDateStr(moment(date[0])),
      toDate: hasDate && toDateStr(moment(date[1])),
    },
    { enabled: hasDate }
  );

  const { data: companies, isFetching: isCompaniesFetching } = useCompanies({
    staleTime: Infinity,
    select: (data) => data.concat({ id: null, name: 'Все' }),
  });

  const { data: operators, isFetching: isOperatorsFetching } = useOperators({
    staleTime: Infinity,
    select: (data) => data.concat({ id: null, shortName: 'Все' }),
  });

  const showExportBtn = ringList && ringList?.length > 0;

  useSetRefreshFn(() => {
    queryClient.invalidateQueries(
      callHistoryQueryKeys.ringList({
        ...searchParams,
        fromDate: hasDate && fromDateStr(moment(date[0])),
        toDate: hasDate && toDateStr(moment(date[1])),
      })
    );
  }, [params]);

  return (
    <section className={styles.root}>
      <header className={styles.header}>
        <div className={styles.col}>
          <SelectItem
            ringListLoading={isRingListFetching}
            defaultBtnText="Выбрать УК"
            filterData={callHistoryFilters.companyId}
            items={companies}
            itemsLoading={isCompaniesFetching}
          />
          <SelectItem
            ringListLoading={isRingListFetching}
            defaultBtnText="Выбрать оператора"
            filterData={callHistoryFilters.operatorId}
            items={operators}
            itemsLoading={isOperatorsFetching}
            contentKey="shortName"
          />
          <SelectPeriod disabled={isRingListFetching} />
        </div>
        <div className={styles.col}>
          {showExportBtn && (
            <Tooltip title={`Экспорт истории звонков (${ringList?.length})`}>
              <div
                className={styles.downloadBtn}
                onClick={() => exportToExcel(ringList)}
              >
                <Icon
                  style={{ color: 'white', fontSize: 18 }}
                  type="download"
                />
              </div>
            </Tooltip>
          )}
          <SearchItem
            filterData={callHistoryFilters.requestId}
            text="№ заявки"
          />
          <SearchItem
            filterData={callHistoryFilters.phone}
            text="Телефон"
          />
        </div>
      </header>
      <CallList
        calls={ringList}
        isCallsLoading={isRingListFetching}
      />
      <ListenRecordModal />
    </section>
  );
};

export default CallHistory;
